<template lang="pug">
.page-layout
	slot(
		v-for='i in numOfSlideOuts'
		:name='`slideout-${i}`'
	)
	.page-wrapper.content-container
		.top-bar
			.title-container
				h1.title {{ heading.title }}
				p.description {{ heading.description }}
			slot.link-container(name='link-container')
		.content
			slot.content-wrapper(name='content')
</template>

<script>
export default {
	name : 'page-layout',

	props : {
		numOfSlideOuts : {
			type    : Number,
			default : 1,
		},
		heading : {
			type : Object,
		},
	},
};
</script>

<style lang="scss">

.page-layout {
	overflow-x: auto;
	flex: 1 1 0;

	.content-container {
		font-family: 'Poppins', sans-serif;
		height: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
		z-index: 1;

		// From asset-viewer
		.page-wrapper {
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		.top-bar {
			display: flex;
			flex-flow: row;
			justify-content: space-between;
			padding: 25px 45px 10px 45px;
			flex: 0 0 auto;
			position: relative;
			z-index: 11;

			.title-container {
				display: flex;
				flex-flow: column;

				.title {
					color: $input-color;
				}

				.description {
					color: $color-primary;
					padding-top: 5px;
				}
			}

			.link-container {
				display: flex;
				flex-flow: row;
				position: relative;
				align-items: center;

				a {
					padding: 15px;
				}

				a, h3 {
					font-size: 16px;
				}

				.alter,
				.map {
					color: $input-color;
				}

				.button {
					transition: .2s ease-in-out;
				}

				.expand-container {
					margin: 0 15px;

					h3 {
						font-weight: 700;
					}

					.button {
						font-weight: 500;
					}
				}

				:nth-child(1) {
					margin-left: 0;
				}

				:nth-last-child(1) {
					margin-right: 0;
				}
			}
		}

		.content {
			flex: 1 1 auto;
			overflow: hidden;

			 .asset-table,
			 .asset-table > .slot-wrapper,
			 .asset-table > .slot-wrapper .space-table {
				height: 100%;
			}

			.content-wrapper .asset-table > .slot-wrapper .space-table {
				display: flex;
				flex-direction: column;

				.search {
					flex-shrink: 0;
				}

				.table-wrapper {
					flex: 1 1 0;
					overflow-y: scroll;
				}
			}

			.space-table {
				max-height: 100%;
				overflow: hidden;
				display: flex;
				flex-flow: column;
			}

			table {
				z-index: 1;
			}

			.search,
			table {
				position: relative;
			}

			.search {
				z-index: 10;
			}

			table {
				z-index: 2;
			}

			tr.headers {
				box-shadow: $box-shadow__card;
			}

			.side-sheet {
				width: 100%;

				> .page {
					width: 100%;
					overflow: auto;

					.buttons-container {

						.icon-pencil {
							margin-right: 50px!important;
						}
					}
				}
			}
		}
	}
}

@media only screen and ( max-width: 640px ) {
	.page-layout .link-container,
	.page-layout .asset-search .buttons {
		display: none !important;
	}

	.page-layout.above-side-nav {
		z-index: 150;
	}

	.page-layout .content-container .pagination {
		left: 0 !important;
		width: 100% !important;
	}
}
</style>
